import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-share-download-zip',
  templateUrl: './share-download-zip.component.html',
  styleUrls: ['../../download-zip/download-zip.component.css']
})
export class ShareDownloadZipComponent implements OnInit {

   private id: string;
   private timer: any;
   progress = 0;
   error: string;
   private taskId = -1;
   @ViewChild('cancel') cancel: MatButton;
   private etax = false;
   total = 0;
   done = 0;
   filesAdded = 0;
   totalFiles = 0;
   listIds = [];

   constructor(private dialogRef: MatDialogRef<ShareDownloadZipComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {

   }

   ngOnInit(): void {
      const that = this;
      this.data.service.post('/share-public/multiple/download', this.data.idList)
         .subscribe(data => {
            this.etax = data.etax;
            if (this.etax) {
               this.totalFiles = data.totalFiles;
               that.timer = setInterval(() => {
                  that.checkStatusETax(data.children);
               }, 500);
            } else {
               that.id = data.nodeRef;
               that.timer = setInterval(() => {
                  that.checkStatus();
               }, 500);
            }
         });
   }

   private checkStatus(): void {
      const that = this;
      this.data.service.get('/share-public/download/status?id=' + this.id)
         .subscribe(data => {
            if (data.done === data.total && data.status === 'DONE' && data.filesAdded === data.totalFiles) {
               clearInterval(that.timer);
               that.progress = 100;
               that.cancel.disabled = true;
               location.href = that.data.service.url + '/share-public/download?id=' + that.id
                  + '&name=' + encodeURIComponent(that.data.name + '.zip');

               if (this.etax) {
                  setTimeout(() => {
                     this.listIds.push(this.id);
                     that.cleanAndCloseETax(this.cancel, this.listIds);
                  }, 500);
               } else {
                  setTimeout(() => {
                     that.cleanAndClose(this.cancel);
                  }, 500);
               }
            } else {
               let calProgress = data.done * 100 / data.total;
               calProgress = isNaN(calProgress) ? 0 : calProgress;
               that.progress = Math.floor(calProgress);
            }
         }, error => {
            that.error = error;
            clearInterval(that.timer);
            that.delete();
         });
   }

   private checkStatusETax(children: any): void {
      const that = this;
      this.listIds = [];
      this.filesAdded = 0;
      this.total = 0;
      this.done = 0;
      for (const node of children) {
         that.id = node.nodeRef.replace('workspace://SpacesStore/', '');
         this.listIds.push(that.id);
         this.data.service.get('/share-public/download/status?id=' + this.id)
            .subscribe(data => {
               this.total += parseInt(data.total, 10);
               this.done += parseInt(data.done, 10);
               this.filesAdded += parseInt(data.filesAdded, 10);
               if (data.done === data.total && data.status === 'DONE' && data.filesAdded === data.totalFiles) {
                  if (this.filesAdded === this.totalFiles && this.total === this.done) {
                     clearInterval(that.timer);
                     that.progress = 100;
                     that.cancel.disabled = true;
                     this.data.service.post('/share-public/etax/multiple/download?', this.listIds)
                        .subscribe(dataZip => {
                           that.id = dataZip.nodeRef;
                           that.timer = setInterval(() => {
                              that.checkStatus();
                           }, 500);
                        });
                  }
               } else {
                  let calProgress = data.done * 100 / data.total;
                  calProgress = isNaN(calProgress) ? 0 : calProgress;
                  that.progress = Math.floor(calProgress);
               }
            }, error => {
               that.error = error;
               clearInterval(that.timer);
               that.deleteEtax(children);
            });
      }
   }

   cleanAndClose(cancel: MatButton): void {
      cancel.disabled = true;
      if (this.id) {
         const that = this;
         this.delete().subscribe(() => { that.dialogRef.close(); }, () => { that.dialogRef.close(); });
      } else {
         this.dialogRef.close();
      }
   }

   cleanAndCloseETax(cancel: MatButton, children: any): void {
      cancel.disabled = true;
      if (children) {
         const that = this;
         this.deleteEtax(children).subscribe(() => { that.dialogRef.close(); }, () => { that.dialogRef.close(); });
      } else {
         this.dialogRef.close();
      }
   }

   private delete(): Observable<any> {
      return this.data.service.delete('/share-public/download?id=' + this.id);
   }

   private deleteEtax(children: any): Observable<boolean> {
      let result;
      for (const node of children) {
         this.id = node.replace('workspace://SpacesStore/', '');
         result = this.data.service.delete('/share-public/download?id=' + this.id);
      }
      return result;
   }

}
